/* Local note-name filtering only; existing scent matching is independent. */
(() => {
  const normalize = (value) => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim().replace(/\s+/g, ' ');
  document.querySelectorAll('[data-ano]').forEach((root) => {
    const box = root.querySelector('[data-ano-search]');
    if (!box || root.dataset.anoSearchReady) return;
    const input = box.querySelector('[data-ano-search-input]');
    const clear = box.querySelector('[data-ano-search-clear]');
    const status = box.querySelector('[data-ano-search-status]');
    const empty = box.querySelector('[data-ano-search-empty]');
    const entries = [...root.querySelectorAll('[data-ano-entry]')];
    const groups = [...root.querySelectorAll('.ano__group')];
    const letters = [...root.querySelectorAll('.ano__letter-list a')];
    if (!input || !clear || !status || !empty || !entries.length) return;
    root.dataset.anoSearchReady = 'true';
    const update = () => {
      const query = normalize(input.value);
      let count = 0;
      entries.forEach((entry) => {
        const name = entry.querySelector('.ano__name');
        entry.hidden = !normalize(name ? name.textContent : '').includes(query);
        if (!entry.hidden) count += 1;
      });
      groups.forEach((group) => { group.hidden = ![...group.querySelectorAll('[data-ano-entry]')].some((entry) => !entry.hidden); });
      letters.forEach((link) => {
        const group = groups.find((item) => '#' + item.id === link.getAttribute('href'));
        if (group) link.parentElement.hidden = group.hidden;
      });
      empty.hidden = count > 0;
      status.textContent = query ? count + (count === 1 ? ' note found.' : ' notes found.') : '';
      clear.disabled = !input.value;
    };
    input.addEventListener('input', update);
    clear.addEventListener('click', () => { input.value = ''; update(); input.focus(); });
    window.addEventListener('hashchange', () => {
      let id;
      try { id = decodeURIComponent(location.hash.slice(1)); } catch (_) { return; }
      const target = entries.find((entry) => entry.id === id) || groups.find((group) => group.id === id);
      if (!target || !input.value) return;
      input.value = ''; update();
      target.scrollIntoView({ block: 'start', behavior: 'instant' });
    });
    update(); box.hidden = false;
  });
})();
